import Marquee from "react-fast-marquee";
import { Reveal } from "./Reveal";
import { useSite } from "../context/SiteContext";

export default function TeamMarquee() {
  const { team } = useSite();
  if (!team || team.length === 0) return null;

  return (
    <section data-testid="team-section" className="bg-bone py-20 md:py-28 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 mb-12">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">Our People</p>
          <h2 className="font-serif text-4xl md:text-6xl tracking-tight text-forest leading-none">
            Faculty &amp; Employees
          </h2>
        </Reveal>
      </div>

      <Marquee speed={40} gradient direction="left" pauseOnHover className="py-2">
        {team.map((m, i) => (
          <figure key={m.id || i} data-testid="team-item" className="flex flex-col items-center text-center mx-6 md:mx-10">
            <div className="w-32 h-32 md:w-44 md:h-44 rounded-full overflow-hidden ring-2 ring-gold/40 ring-offset-4 ring-offset-bone shadow-lg">
              <img src={m.photo} alt={m.name} className="w-full h-full object-cover" />
            </div>
            <figcaption className="mt-4">
              <p className="font-serif text-lg md:text-xl text-forest">{m.name}</p>
              {m.role && <p className="text-xs uppercase tracking-widest text-muted mt-1">{m.role}</p>}
            </figcaption>
          </figure>
        ))}
      </Marquee>
    </section>
  );
}
